import React from 'react';
import ReactMarkdown from 'react-markdown';
import './Markdown.css';

interface MarkdownProps {
  children?: string | null;
  className?: string;
  /** Render link syntax as plain text (for content nested inside a <Link>/<a>) */
  disallowLinks?: boolean;
  'data-testid'?: string;
}

const Markdown: React.FC<MarkdownProps> = ({ children, className, disallowLinks, 'data-testid': testId }) => {
  if (!children) return null;

  return (
    <div className={['markdown-content', className].filter(Boolean).join(' ')} data-testid={testId}>
      <ReactMarkdown
        disallowedElements={disallowLinks ? ['a'] : undefined}
        unwrapDisallowed={disallowLinks}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default Markdown;
